import React from 'react';

import { Button } from '@mui/material';

import { BOOK_LIVE_DEMO_URL } from 'app/constants';

import background from './assets/background.png?file';
import WandIcon from './assets/wand.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Advertising: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles({ background });
    return (
        <div className={cx(classes.container, className)}>
            <WandIcon />
            <p className={classes.title}>
                <span className={classes.accent}>{'Transform'}</span>
                {' Your Security Services'}
            </p>
            <p className={classes.description}>
                {
                    "Elevate your offerings with Vulners' advanced Vulnerability Intelligence. Contact us for a demo and discover the difference comprehensive, actionable intelligence can make in your security strategy."
                }
            </p>
            <Button variant="contained" className={classes.button} href={BOOK_LIVE_DEMO_URL}>
                {'Book a live demo'}
            </Button>
        </div>
    );
};

export default Advertising;
